import styled from 'styled-components';

const StyledParagraph = styled.p`
  border-bottom: 1px solid ${(props) => props.theme.colors.light};
  height: 13px;
`;

const StyledSpan = styled.span`
  background: ${(props) => props.theme.colors.white};
`;

interface SpacerHrProps {
  label?: string;
  block?: boolean;
}

const SpacerHr = ({ label, block = false }: SpacerHrProps) => (
  <StyledParagraph className={`text-center mb-4 ${block || 'mx-3'}`}>
    {label && <StyledSpan className="px-3">{label}</StyledSpan>}
  </StyledParagraph>
);

export default SpacerHr;
